'use client';
import { useEffect } from 'react';

interface ProductViewDataLayerProps {
  id: number;
  name: string;
  sku: string;
  price: string | number;
  image?: string;
  currency?: string;
}

export const ProductViewDataLayer: React.FC<ProductViewDataLayerProps> = ({
  id,
  name,
  sku,
  price,
  image,
  currency = 'USD',
}) => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        items: [
          {
            item_id: id,
            item_name: name,
            item_sku: sku,
            price: price,
            image_url: image,
            currency,
          },
        ],
      },
    });
  }, [id, name, sku, price, image, currency]);

  return null;
};
